// src/services/router.ts
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import MainLayout from '@/views/MainLayout.vue'
import Connect from '@/views/Connect.vue'
import Calls from '@/views/Calls.vue'
import Diagnostics from '@/views/Diagnostics.vue'
import Login from '@/views/Login.vue'
import AdminPanel from '@/views/AdminPanel.vue'
import { handleLogout as authLogout, authState } from '@/services/auth'; // Combined imports

const routes: Array<RouteRecordRaw> = [
  { path: '/login', component: Login, name: 'Login' },
  { path: '/',
    component: MainLayout,
    children: [
      { path: '', redirect: '/connect' },
      { path: '/connect', component: Connect },
      { path: '/calls', component: Calls },
      { path: '/admin', component: AdminPanel }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guards can also live here
/*
router.beforeEach((to, from, next) => {
  // logic...
  next();
});
*/

router.beforeEach((to, from) => {
  // Replace this with your actual auth state reference
  const isAuthenticated = authState.isLoggedIn

  // 1. Check if the user is NOT logged in
  // 2. Ensure they aren't already going to the Login page (to avoid infinite loops)
  if (!isAuthenticated && to.name !== 'Login') {
    return { 
      name: 'Login', 
      // Optional: Save the attempted URL to redirect back after login
      query: { redirect: to.fullPath } 
    }
  }
})

export default router;
